import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 16 17"
  return (
    <>
      <path
        d="M6.37386 4.73136H3.9533C3.66358 4.73136 3.42993 4.49772 3.42993 4.208C3.42993 3.91828 3.66358 3.68463 3.9533 3.68463H6.37386C6.66358 3.68463 6.89722 3.91828 6.89722 4.208C6.89722 4.49772 6.66358 4.73136 6.37386 4.73136Z"
        fill={color}
      />
      <path
        d="M7.63554 6.59122H3.9533C3.66358 6.59122 3.42993 6.35758 3.42993 6.06786C3.42993 5.77814 3.66358 5.54449 3.9533 5.54449H7.63554C7.92526 5.54449 8.15891 5.77814 8.15891 6.06786C8.15891 6.35758 7.92526 6.59122 7.63554 6.59122Z"
        fill={color}
      />
      <path
        d="M8.85984 8.46036H3.9533C3.66358 8.46036 3.42993 8.22672 3.42993 7.937C3.42993 7.64728 3.66358 7.41364 3.9533 7.41364H8.85984C9.14956 7.41364 9.3832 7.64728 9.3832 7.937C9.3832 8.22672 9.14956 8.46036 8.85984 8.46036Z"
        fill={color}
      />
      <path
        d="M10 10.3295H3.9533C3.66358 10.3295 3.42993 10.0959 3.42993 9.80614C3.42993 9.51642 3.66358 9.28278 3.9533 9.28278H10C10.2897 9.28278 10.5234 9.51642 10.5234 9.80614C10.5234 10.0959 10.2897 10.3295 10 10.3295Z"
        fill={color}
      />
      <path
        d="M11.0748 12.1894H3.9533C3.66358 12.1894 3.42993 11.9557 3.42993 11.666C3.42993 11.3763 3.66358 11.1426 3.9533 11.1426H11.0748C11.3645 11.1426 11.5982 11.3763 11.5982 11.666C11.5982 11.9557 11.3645 12.1894 11.0748 12.1894Z"
        fill={color}
      />
      <path
        d="M12.0468 14.0585H3.9533C3.66358 14.0585 3.42993 13.8248 3.42993 13.5351C3.42993 13.2454 3.66358 13.0117 3.9533 13.0117H12.0468C12.3365 13.0117 12.5701 13.2454 12.5701 13.5351C12.5701 13.8248 12.3365 14.0585 12.0468 14.0585Z"
        fill={color}
      />
      <path
        d="M14.4393 16.9557H1.56075C0.700934 16.9557 0 16.2548 0 15.3949V2.51644C0 1.65662 0.700934 0.955688 1.56075 0.955688H14.4393C15.2991 0.955688 16 1.65662 16 2.51644V15.3949C16 16.2548 15.2991 16.9557 14.4393 16.9557ZM1.56075 2.00242C1.28037 2.00242 1.04673 2.23606 1.04673 2.51644V15.3949C1.04673 15.6753 1.28037 15.909 1.56075 15.909H14.4393C14.7196 15.909 14.9533 15.6753 14.9533 15.3949V2.51644C14.9533 2.23606 14.7196 2.00242 14.4393 2.00242H1.56075Z"
        fill={color}
      />
    </>
  );
}
